import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setCurrentPage } from "../store/navSlice";
import ServiceDetailsPopup from "./ServiceDetailsPopup";
import {
  setActiveServiceTab,
  toggleServiceFaq,
  setActiveServiceFilter,
} from "../store/serviceSlice";
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  Drawer,
  List,
  AppBar,
  Toolbar,
  ListItem,
  ListItemText,
  keyframes,
  CardContent,
  CardMedia,
  Chip,
  Stack,
  Tabs,
  Tab,
  Rating,
  useMediaQuery,
  Paper,
  Divider,
  Modal,
  IconButton,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ScheduleIcon from "@mui/icons-material/Schedule";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ChatButton from "../components/freeChatComponent/ChatButton";
import "../css/Services.css";
import MenuIcon from "@mui/icons-material/Menu";
// Import commercial images
import commercial1 from "../images/commercial/bedroom1 .png";
import commercial2 from "../images/commercial/bedroom10.png";
import commercial3 from "../images/commercial/bedroom11.png";
import commercial4 from "../images/commercial/bedroom13.jpg";
import commercial5 from "../images/commercial/bedroom2.png";
import commercial6 from "../images/commercial/bedroom3.jpg";
import commercial7 from "../images/commercial/bedroom6.jpg";
import commercial8 from "../images/commercial/bedroom7.jpg";

// Import renovation images
import renovation1 from "../images/renovation/renovation1.jpg";
import renovation2 from "../images/renovation/renovation2.jpg";
import renovation3 from "../images/renovation/renovation3.jpg";
import renovation4 from "../images/renovation/renovation4.jpg";
import renovation5 from "../images/renovation/renovation5.jpg";
import renovation6 from "../images/renovation/renovation6.jpg";
import renovation7 from "../images/renovation/renovation7.jpg";
import renovation8 from "../images/renovation/renovation8.jpg";
import renovation9 from "../images/renovation/renovation9.jpg";

// Import residential images
import residential4 from "../images/residential/residential4.jpg";
import residential5 from "../images/residential/residential5.png";
import residential6 from "../images/residential/residential6.png";
import residential7 from "../images/residential/residential7.png";
import residential8 from "../images/residential/residential8.jpg";
import residential9 from "../images/residential/residential9.jpg";
import residential10 from "../images/residential/residential10.jpg";
import residential11 from "../images/residential/residential11.png";
import residential12 from "../images/residential/residential12.jpeg";
import residential13 from "../images/residential/residential13.jpg";

import ConsultationFormDialog from "./Consultation";
// Import new project images
import newProject1 from "../images/newProject/newProject1.png";
import newProject2 from "../images/newProject/newProject2.jpg";
import newProject3 from "../images/newProject/newProject3.jpg";
import newProject4 from "../images/newProject/newProject4.jpg";
import newProject5 from "../images/newProject/newProject5.jpg";
import newProject10 from "../images/newProject/newProject10.png";
import newProject11 from "../images/newProject/newProject11.png";
import newProject12 from "../images/newProject/newProject12.png";
import newProject14 from "../images/newProject/newProject14.png";
import newProject15 from "../images/newProject/newProject15.jpg";
import LogoImage from "../images/decodia-logo.png";

import Service_decodia from "../vedio/Service_decodia.mp4";
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideDown = keyframes`
  from { 
    opacity: 0;
    transform: translateY(-10px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
`;

const underline = keyframes`
  from { width: 0; }
  to { width: 100%; }
`;

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;
const pulseAnimation = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
`;
const shimmerAnimation = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openForm, setOpenForm] = useState(false);

  const { menuItems } = useSelector((state) => state.navigation);

  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const currentPath = location.pathname;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigation = (path, label) => {
    navigate(path);
    dispatch(setCurrentPage(label));
    setDrawerOpen(false);
  };

  const desktopMenu = (
    <Box
      sx={{
        display: "flex",
        gap: 4,
        alignItems: "center",
        animation: `${fadeIn} 0.6s ease-out`,
      }}
    >
      {menuItems.map((item, index) => (
        <Box
          key={item.id}
          sx={{
            animation: `${slideDown} 0.4s ease-out ${index * 0.05}s forwards`,
            opacity: 0,
          }}
        >
          <Button
            onClick={() => handleNavigation(item.path, item.label)}
            sx={{
              color: "white",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.95rem",
              position: "relative",
              padding: "8px 12px",
              minWidth: "auto",
              borderRadius: "4px",
              transition: "all 0.3s ease",

              "&:hover": {
                color: "#EED688",
                background:
                  "linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(238, 214, 136, 0.1))",
                transform: "translateY(-2px)",

                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "2px",
                  bottom: "0",
                  left: "0",
                  background:
                    "linear-gradient(90deg, #FF6B35, #FF8E53, #EED688)",
                  animation: `${underline} 0.3s ease-out`,
                  borderRadius: "2px",
                },
              },

              ...(currentPath === item.path && {
                color: "#FF6B35",
                fontWeight: 700,
                background:
                  "linear-gradient(135deg, rgba(255, 107, 53, 0.15), rgba(255, 142, 83, 0.1))",

                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "2px",
                  bottom: "0",
                  left: "0",
                  background:
                    "linear-gradient(90deg, #FF6B35, #FF8E53, #FF6B35)",
                  borderRadius: "2px",
                  animation: `${pulseAnimation} 2s infinite`,
                },
              }),
            }}
          >
            {item.label}
          </Button>
        </Box>
      ))}

      <Box
        sx={{
          animation: `${slideDown} 0.4s ease-out 0.3s forwards`,
          opacity: 0,
          ml: 1,
        }}
      >
        <Button
          variant="contained"
          onClick={() => setOpenForm(true)}
          sx={{
            background: "linear-gradient(45deg, #FF6B35 0%, #FF8E53 100%)",
            backgroundSize: "200% 200%",
            color: "white",
            fontWeight: 700,
            borderRadius: "8px",
            padding: "10px 24px",
            fontSize: "0.95rem",
            textTransform: "none",
            position: "relative",
            overflow: "hidden",
            animation: `${pulseAnimation} 3s infinite`,
            transition: "all 0.3s ease",

            "&:hover": {
              background: "linear-gradient(45deg, #E55A2B 0%, #FF7B42 100%)",
              transform: "translateY(-2px)",
              boxShadow: "0 8px 20px rgba(255, 107, 53, 0.3)",
              animation: `${pulseAnimation} 1.5s infinite`,

              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
                animation: `${shimmerAnimation} 1.5s ease-out`,
              },
            },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <ChatBubbleIcon sx={{ fontSize: 18 }} />
            Free Consultation
          </Box>
        </Button>

        <ConsultationFormDialog
          open={openForm}
          onClose={() => setOpenForm(false)}
        />
      </Box>
    </Box>
  );

  const mobileMenu = (
    <>
      <IconButton
        onClick={() => setDrawerOpen(true)}
        sx={{
          color: "white",
          animation: `${fadeIn} 0.5s ease-out`,
          transition: "transform 0.3s ease",

          "&:hover": {
            transform: "rotate(90deg)",
          },
        }}
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: 280,
            background: "linear-gradient(135deg, #0F0F0F 0%, #1a1a1a 100%)",
            color: "white",
            animation: `${fadeIn} 0.3s ease-out`,
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <img
              src={LogoImage}
              alt="DECODIA"
              style={{ height: 50, width: "auto" }}
            />
            <IconButton
              onClick={() => setDrawerOpen(false)}
              sx={{
                color: "white",
                transition: "transform 0.3s ease",

                "&:hover": {
                  transform: "rotate(90deg)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <List>
            {menuItems.map((item, index) => (
              <ListItem
                key={item.id}
                button
                onClick={() => handleNavigation(item.path, item.label)}
                sx={{
                  py: 2,
                  mb: 1,
                  borderRadius: "4px",
                  backgroundColor:
                    currentPath === item.path
                      ? "rgba(255, 107, 53, 0.1)"
                      : "transparent",
                  animation: `${fadeIn} 0.3s ease-out ${index * 0.05}s forwards`,
                  opacity: 0,
                  transition: "all 0.3s ease",

                  "&:hover": {
                    backgroundColor: "rgba(255, 107, 53, 0.05)",
                    paddingLeft: "20px",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    color: currentPath === item.path ? "#FF6B35" : "white",
                  }}
                />
              </ListItem>
            ))}
          </List>

          <Box sx={{ mt: 3, p: 2 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setOpenForm(true)}
              sx={{
                background: "linear-gradient(45deg, #FF6B35 30%, #FF8E53 90%)",
                color: "white",
                fontWeight: 600,
                borderRadius: "8px",
                padding: "14px 24px",
                animation: `${pulseAnimation} 3s infinite`,
                transition: "all 0.3s ease",

                "&:hover": {
                  background:
                    "linear-gradient(45deg, #E55A2B 30%, #FF7B42 90%)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 15px rgba(255, 107, 53, 0.3)",
                  animation: `${pulseAnimation} 1.5s infinite`,
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                <ChatBubbleIcon sx={{ fontSize: 18 }} />
                Free Consultation
              </Box>
            </Button>
          </Box>
        </Box>
      </Drawer>
      <ConsultationFormDialog
        open={openForm}
        onClose={() => setOpenForm(false)}
      />
    </>
  );

  return (
    <AppBar
      position="absolute"
      elevation={0}
      sx={{
        background: "transparent",
        backdropFilter: scrolled ? "blur(10px)" : "none",
        transition: "all 0.3s ease",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.1)" : "none",
        animation: `${fadeIn} 0.6s ease-out`,
      }}
    >
      <Container maxWidth="1400px" sx={{ margin: 0, px: 0, py: 2 }}>
        <Toolbar
          sx={{
            minHeight: 70,
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "1400px",
            margin: "0 auto",
          }}
        >
          <Box
            onClick={() => handleNavigation("/", "Home")}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              transition: "transform 0.3s ease",

              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            <img
              src={LogoImage}
              alt="DECODIA"
              style={{ height: 60, width: "auto" }}
            />
          </Box>

          {!isMobile ? desktopMenu : mobileMenu}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
const Services = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [openForm, setOpenForm] = useState(false);
  const location = useLocation();
  // State for service details popup
  const [selectedService, setSelectedService] = useState(null);
  const [servicePopupOpen, setServicePopupOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // Main navigation effect
  useEffect(() => {
    // CRITICAL: Scroll to top FIRST, before anything else
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    console.log("Services page mounted");
    console.log("Location state:", location.state);
    console.log("Current categories:", categories);

    dispatch(setCurrentPage("Services"));
    setNavigationComplete(false);

    // Reset states on page load
    setScrollingToService(false);
    setOpeningGallery(false);
    setGalleryType(null);
    setTabSelected(false);

    // Check navigation state from Home page
    if (location.state) {
      const {
        scrollToService,
        openCommercialGallery,
        openRenovationGallery,
        openResidentialGallery,
        openNewProjectGallery,
        serviceName,
      } = location.state;

      console.log("Navigation state detected:", {
        scrollToService,
        openCommercialGallery,
        openRenovationGallery,
        openResidentialGallery,
        openNewProjectGallery,
        serviceName,
      });

      // Add a delay to ensure page is at top before handling gallery navigation
      setTimeout(() => {
        // Handle gallery navigation based on type
        if (openCommercialGallery) {
          console.log("Opening commercial gallery from Home page");
          handleGalleryNavigation("commercial", "Commercial Interior Design");
        } else if (openRenovationGallery) {
          console.log("Opening renovation gallery from Home page");
          handleGalleryNavigation("renovation", "Renovation & Remodeling");
        } else if (openResidentialGallery) {
          console.log("Opening residential gallery from Home page");
          handleGalleryNavigation("residential", "Residential Interior Design");
        } else if (openNewProjectGallery) {
          console.log("Opening new project gallery from Home page");
          handleGalleryNavigation("newProject", "New Project Construction");
        } else if (scrollToService) {
          console.log("Scrolling to service from Home page:", serviceName);
          handleServiceScrollNavigation(scrollToService);
        }
      }, 300); // 300ms delay to ensure scroll to top completes

      // Clear location state after processing
      setTimeout(() => {
        navigate(location.pathname, { replace: true });
      }, 3000);
    }

    // Set navigation as complete after initial load
    setTimeout(() => {
      setNavigationComplete(true);
    }, 1500);
  }, [dispatch, location.state, navigate, location.pathname]);
  // Refs for scrolling
  const galleriesRef = useRef(null);
  const servicesContainerRef = useRef(null);

  // State for loading and navigation
  const [scrollingToService, setScrollingToService] = useState(false);
  const [openingGallery, setOpeningGallery] = useState(false);
  const [galleryType, setGalleryType] = useState(null);
  const [tabSelected, setTabSelected] = useState(false);
  const [navigationComplete, setNavigationComplete] = useState(false);

  // State for Galleries
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeGallery, setActiveGallery] = useState("commercial");

  // Images data for all galleries
  const commercialImages = [
    {
      id: 1,
      src: commercial1,
      title: "Modern Office Space",
      category: "Office",
    },
    {
      id: 2,
      src: commercial2,
      title: "Restaurant Interior",
      category: "Restaurant",
    },
    {
      id: 3,
      src: commercial3,
      title: "Retail Store Design",
      category: "Retail",
    },
    { id: 4, src: commercial4, title: "Hotel Lobby", category: "Hospitality" },
    { id: 5, src: commercial5, title: "Conference Room", category: "Office" },
    { id: 6, src: commercial6, title: "Cafe Design", category: "Restaurant" },
    { id: 7, src: commercial7, title: "Boutique Store", category: "Retail" },
    { id: 8, src: commercial8, title: "Spa & Wellness", category: "Wellness" },
  ];

  const renovationImages = [
    {
      id: 1,
      src: renovation1,
      title: "Kitchen Renovation",
      category: "Kitchen",
    },
    {
      id: 2,
      src: renovation2,
      title: "Bathroom Makeover",
      category: "Bathroom",
    },
    {
      id: 3,
      src: renovation3,
      title: "Living Room Remodel",
      category: "Living Room",
    },
    {
      id: 4,
      src: renovation4,
      title: "Bedroom Transformation",
      category: "Bedroom",
    },
    {
      id: 5,
      src: renovation5,
      title: "Complete Home Renovation",
      category: "Full House",
    },
    {
      id: 6,
      src: renovation6,
      title: "Modern Kitchen Upgrade",
      category: "Kitchen",
    },
    { id: 7, src: renovation7, title: "Luxury Bathroom", category: "Bathroom" },
    {
      id: 8,
      src: renovation8,
      title: "Open Concept Renovation",
      category: "Living Room",
    },
    {
      id: 9,
      src: renovation9,
      title: "Master Suite Renovation",
      category: "Bedroom",
    },
  ];

  const residentialImages = [
    {
      id: 1,
      src: residential4,
      title: "Modern Living Room",
      category: "Living Room",
    },
    {
      id: 2,
      src: residential5,
      title: "Contemporary Bedroom",
      category: "Bedroom",
    },
    {
      id: 3,
      src: residential6,
      title: "Elegant Dining Area",
      category: "Dining Room",
    },
    {
      id: 4,
      src: residential7,
      title: "Cozy Family Room",
      category: "Family Room",
    },
    {
      id: 5,
      src: residential8,
      title: "Luxury Master Suite",
      category: "Bedroom",
    },
    { id: 6, src: residential9, title: "Modern Kitchen", category: "Kitchen" },
    {
      id: 7,
      src: residential10,
      title: "Home Office Design",
      category: "Office",
    },
    {
      id: 8,
      src: residential11,
      title: "Entertainment Room",
      category: "Entertainment",
    },
    { id: 9, src: residential12, title: "Guest Room", category: "Bedroom" },
    { id: 10, src: residential13, title: "Kids Room", category: "Children" },
  ];

  const newProjectImages = [
    {
      id: 1,
      src: newProject1,
      title: "New Construction Villa",
      category: "Villa",
    },
    {
      id: 2,
      src: newProject2,
      title: "Modern Apartment",
      category: "Apartment",
    },
    { id: 3, src: newProject3, title: "Luxury House", category: "House" },
    { id: 4, src: newProject4, title: "Contemporary Home", category: "Home" },
    {
      id: 5,
      src: newProject5,
      title: "Smart Home Design",
      category: "Smart Home",
    },
    {
      id: 6,
      src: newProject10,
      title: "Architectural Design",
      category: "Architecture",
    },
    {
      id: 7,
      src: newProject11,
      title: "Interior Planning",
      category: "Planning",
    },
    {
      id: 8,
      src: newProject12,
      title: "Space Optimization",
      category: "Optimization",
    },
    { id: 9, src: newProject14, title: "Modern Layout", category: "Layout" },
    {
      id: 10,
      src: newProject15,
      title: "Premium Materials",
      category: "Materials",
    },
  ];

  const {
    hero,
    categories,
    allServices,
    popularServices,
    serviceProcess,
    serviceBenefits,
    faqs,
    serviceProjects,
    testimonials,
    cta,
    activeTab,
    activeFilter,
    expandedFaqs,
  } = useSelector((state) => state.services);

  // Get current gallery type based on active tab
  const getGalleryTypeForTab = () => {
    if (activeTab === 0) return "residential"; // All Services tab
    if (!categories || categories.length === 0) return "residential";

    const category = categories[activeTab - 1];
    const categoryName = category.name.toLowerCase();

    if (categoryName.includes("commercial")) return "commercial";
    if (categoryName.includes("renovation")) return "renovation";
    if (categoryName.includes("residential")) return "residential";
    if (categoryName.includes("new") || categoryName.includes("construction"))
      return "newProject";

    return "all";
  };

  // Check if a gallery should be shown based on active tab
  const shouldShowGallery = (galleryType) => {
    const currentTabGalleryType = getGalleryTypeForTab();

    if (currentTabGalleryType === "all") {
      return true; // Show all galleries for "All Services" tab
    }

    return currentTabGalleryType === galleryType;
  };

  // Main navigation effect
  useEffect(() => {
    console.log("Services page mounted");
    console.log("Location state:", location.state);
    console.log("Current categories:", categories);

    dispatch(setCurrentPage("Services"));
    setNavigationComplete(false);

    // Reset states on page load
    setScrollingToService(false);
    setOpeningGallery(false);
    setGalleryType(null);
    setTabSelected(false);

    // Check navigation state from Home page
    if (location.state) {
      const {
        scrollToService,
        openCommercialGallery,
        openRenovationGallery,
        openResidentialGallery,
        openNewProjectGallery,
        serviceName,
      } = location.state;

      console.log("Navigation state detected:", {
        scrollToService,
        openCommercialGallery,
        openRenovationGallery,
        openResidentialGallery,
        openNewProjectGallery,
        serviceName,
      });

      // Handle gallery navigation based on type
      if (openCommercialGallery) {
        handleGalleryNavigation("commercial", "Commercial Interior Design");
      } else if (openRenovationGallery) {
        handleGalleryNavigation("renovation", "Renovation & Remodeling");
      } else if (openResidentialGallery) {
        handleGalleryNavigation("residential", "Residential Interior Design");
      } else if (openNewProjectGallery) {
        handleGalleryNavigation("newProject", "New Project Construction");
      } else if (scrollToService) {
        handleServiceScrollNavigation(scrollToService);
      }

      // Clear location state after processing
      setTimeout(() => {
        navigate(location.pathname, { replace: true });
      }, 3000);
    }

    // Set navigation as complete after initial load
    setTimeout(() => {
      setNavigationComplete(true);
    }, 1500);
  }, [dispatch, location.state, navigate, location.pathname]);

  // Function to handle gallery navigation
  const handleGalleryNavigation = (type, serviceName) => {
    setOpeningGallery(true);
    setGalleryType(type);

    // Find and select appropriate tab
    let categoryName = "";
    switch (type) {
      case "commercial":
        categoryName = "commercial";
        break;
      case "renovation":
        categoryName = "renovation";
        break;
      case "residential":
        categoryName = "residential";
        break;
      case "newProject":
        categoryName = "new";
        break;
    }

    const category = categories?.find((cat) =>
      cat.name.toLowerCase().includes(categoryName),
    );

    if (category) {
      const categoryIndex = categories.findIndex(
        (cat) => cat.id === category.id,
      );

      if (categoryIndex !== -1) {
        dispatch(setActiveServiceTab(categoryIndex + 1));
        setTabSelected(true);
        setTimeout(() => {
          // Scroll to galleries section
          if (galleriesRef.current) {
            galleriesRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            // Open gallery after scroll completes
            setTimeout(() => {
              console.log(`Opening ${type} gallery modal...`);
              setActiveGallery(type);
              setGalleryOpen(true);
              setOpeningGallery(false);
            }, 1000);
          } else {
            console.error(`Galleries ref not found`);
          }
        }, 800); // Wait for tab switch animation
      }
    } else {
      console.error(`${type} category not found in categories:`, categories);
      setOpeningGallery(false);
    }
  };
  const handleServiceScrollNavigation = (serviceId) => {
    setScrollingToService(true);

    // Find the service to get its category
    const service = allServices?.find((s) => s.id === serviceId);

    if (service && service.categories && service.categories.length > 0) {
      // Find the category and select the corresponding tab
      const categoryName = service.categories[0];
      const category = categories?.find((cat) =>
        cat.name.toLowerCase().includes(categoryName.toLowerCase()),
      );

      if (category) {
        const categoryIndex = categories.findIndex(
          (cat) => cat.id === category.id,
        );
        if (categoryIndex !== -1) {
          dispatch(setActiveServiceTab(categoryIndex + 1));
          console.log(`Selected ${category.name} tab for service`);
        }
      }
    }

    // Scroll to the service after tab selection
    setTimeout(() => {
      scrollToServiceElement(serviceId);
    }, 1000);
  };

  // Handler for opening service details popup
  const handleViewServiceDetails = (service) => {
    setSelectedService(service);
    setServicePopupOpen(true);
  };

  // Handler for closing service details popup
  const handleCloseServicePopup = () => {
    setServicePopupOpen(false);
    setSelectedService(null);
  };
  // Function to scroll to service element
  const scrollToServiceElement = (serviceId) => {
    const element = document.getElementById(`service-${serviceId}`);
    console.log("Looking for service element:", `service-${serviceId}`);

    if (element) {
      console.log("Service element found, scrolling...");
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });

      // Add highlight effect
      element.classList.add("highlight-service");

      // Remove highlight after 3 seconds
      setTimeout(() => {
        element.classList.remove("highlight-service");
        setScrollingToService(false);
      }, 3000);
    } else {
      console.log("Service element not found yet, retrying...");
      // Try again after a delay
      setTimeout(() => {
        const retryElement = document.getElementById(`service-${serviceId}`);
        if (retryElement) {
          retryElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          retryElement.classList.add("highlight-service");
          setTimeout(() => {
            retryElement.classList.remove("highlight-service");
            setScrollingToService(false);
          }, 3000);
        } else {
          console.error("Service element not found after retry");
          setScrollingToService(false);
        }
      }, 1500);
    }
  };

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    dispatch(setActiveServiceTab(newValue));
    setGalleryType(null); // Reset gallery type when tab changes manually
  };

  // Handle FAQ toggle
  const handleFaqToggle = (faqId) => {
    dispatch(toggleServiceFaq(faqId));
  };

  // Handle filter change
  const handleFilterChange = (filter) => {
    dispatch(setActiveServiceFilter(filter));
  };

  // Filter services based on active tab and filter
  const getFilteredServices = () => {
    let filtered = [...(allServices || [])];

    // Filter by tab (category)
    if (activeTab > 0 && categories && categories[activeTab - 1]) {
      const category = categories[activeTab - 1];
      filtered = filtered.filter((service) =>
        service.categories?.includes(category.name),
      );
    }

    // Filter by additional filter
    if (activeFilter !== "all") {
      filtered = filtered.filter((service) =>
        service.tags?.includes(activeFilter),
      );
    }

    return filtered;
  };

  // Gallery Functions
  const openGallery = (type) => {
    console.log(`Opening ${type} gallery manually`);
    setActiveGallery(type);
    setGalleryOpen(true);
    setCurrentImageIndex(0);
  };

  const closeGallery = () => {
    setGalleryOpen(false);
  };

  const nextImage = () => {
    let currentImages = [];
    switch (activeGallery) {
      case "commercial":
        currentImages = commercialImages;
        break;
      case "renovation":
        currentImages = renovationImages;
        break;
      case "residential":
        currentImages = residentialImages;
        break;
      case "newProject":
        currentImages = newProjectImages;
        break;
    }

    setCurrentImageIndex((prevIndex) =>
      prevIndex === currentImages.length - 1 ? 0 : prevIndex + 1,
    );
  };

  const prevImage = () => {
    let currentImages = [];
    switch (activeGallery) {
      case "commercial":
        currentImages = commercialImages;
        break;
      case "renovation":
        currentImages = renovationImages;
        break;
      case "residential":
        currentImages = residentialImages;
        break;
      case "newProject":
        currentImages = newProjectImages;
        break;
    }

    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? currentImages.length - 1 : prevIndex - 1,
    );
  };

  const handleImageClick = (index, type) => {
    setActiveGallery(type);
    setCurrentImageIndex(index);
    setGalleryOpen(true);
  };

  // Get current images based on active gallery
  const getCurrentImages = () => {
    switch (activeGallery) {
      case "commercial":
        return commercialImages;
      case "renovation":
        return renovationImages;
      case "residential":
        return residentialImages;
      case "newProject":
        return newProjectImages;
      default:
        return commercialImages;
    }
  };

  // Get gallery title based on active gallery
  const getGalleryTitle = () => {
    switch (activeGallery) {
      case "commercial":
        return "Commercial Projects Gallery";
      case "renovation":
        return "Renovation Projects Gallery";
      case "residential":
        return "Residential Projects Gallery";
      case "newProject":
        return "New Projects Gallery";
      default:
        return "Projects Gallery";
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!galleryOpen) return;

      if (e.key === "ArrowRight") {
        nextImage();
      } else if (e.key === "ArrowLeft") {
        prevImage();
      } else if (e.key === "Escape") {
        closeGallery();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [galleryOpen, activeGallery]);

  const renderGallery = (type, title, subtitle, color, images, icon) => {
    if (!shouldShowGallery(type)) {
      return null;
    }

    const isSpecificGallery = getGalleryTypeForTab() === type;

    return (
      <Box
        className={`${type}-gallery-section`}
        sx={{
          py: 8,
          backgroundColor: isSpecificGallery ? "none" : "none",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        {!isSpecificGallery && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 0,
            }}
          />
        )}

        <Container
          maxWidth="lg"
          sx={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 2, sm: 3, md: 4 },
          }}
        >
          {/* Gallery Header - Centered */}
          <Box
            sx={{
              textAlign: "center",
              mb: { xs: 4, sm: 6 },
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              className="section-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                color: "white",
                mb: 2,
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              {title}
            </Typography>
            <Typography
              className="section-subtitle"
              variant="h6"
              color="white"
              sx={{
                maxWidth: "800px",
                mx: "auto",
                fontSize: { xs: "1rem", sm: "1.25rem" },
                mb: 3,
                color: "#e9ecef",
                textAlign: "center",
                px: { xs: 2, sm: 0 },
              }}
            >
              {subtitle}
            </Typography>
          </Box>

          {/* Image Grid - Centered */}
          <Grid
            container
            spacing={3}
            sx={{
              mb: 6,
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            {images.map((image, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={image.id}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                <Card
                  sx={{
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    width: "100%",
                    maxWidth: "280px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: theme.shadows[8],
                      "& .gallery-image": {
                        transform: "scale(1.05)",
                      },
                    },
                  }}
                  onClick={() => handleImageClick(index, type)}
                >
                  <Box
                    sx={{
                      position: "relative",
                      overflow: "hidden",
                      paddingTop: "75%",
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={image.src}
                      alt={image.title}
                      className="gallery-image"
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(to bottom, transparent 70%, rgba(0,0,0,0.7) 100%)",
                      }}
                    />
                  </Box>
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      p: 2,
                      background: "white",
                      textAlign: "center",
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight={600} noWrap>
                      {image.title}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* View Full Gallery Button - Centered */}
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              size="large"
              onClick={() => openGallery(type)}
              startIcon={<ArrowForwardIosIcon />}
              sx={{
                px: 6,
                py: 1.5,
                fontSize: "1.1rem",
                fontWeight: 600,
                background: "#FF6B35",
                borderRadius: "8px",
                "&:hover": {
                  background: "#e55a2b",
                },
              }}
            >
              View Full Gallery
            </Button>
            <Typography
              variant="body2"
              color="#f4f1f0ff"
              sx={{
                mt: 2,
                textAlign: "center",
                maxWidth: "500px",
              }}
            >
              Click any image or the button above to view larger versions
            </Typography>
          </Box>
        </Container>
      </Box>
    );
  };

  if (scrollingToService || openingGallery) {
    let serviceName = location.state?.serviceName || "Service";

    if (openingGallery) {
      switch (galleryType) {
        case "commercial":
          serviceName = "Commercial Gallery";
          break;
        case "renovation":
          serviceName = "Renovation Gallery";
          break;
        case "residential":
          serviceName = "Residential Gallery";
          break;
        case "newProject":
          serviceName = "New Project Gallery";
          break;
      }
    }

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          gap: 4,
          p: 4,
          backgroundColor: "#f8f9fa",
        }}
      >
        <Box sx={{ textAlign: "center", maxWidth: 600 }}>
          <Typography
            variant="h4"
            color="primary"
            fontWeight={700}
            gutterBottom
          >
            {openingGallery
              ? `Opening ${serviceName}...`
              : `Taking you to ${serviceName}...`}
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            {openingGallery
              ? `Please wait while we load our ${serviceName}. This will only take a moment.`
              : `Redirecting you to the ${serviceName} section. This will only take a moment.`}
          </Typography>
        </Box>

        <Box sx={{ position: "relative", width: 120, height: 120 }}>
          <CircularProgress
            size={120}
            thickness={4}
            sx={{
              color: "primary.main",
              position: "absolute",
              animation: "pulse 2s ease-in-out infinite",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            {openingGallery ? (
              <DesignServicesIcon
                sx={{ fontSize: 40, color: "primary.main" }}
              />
            ) : (
              <DesignServicesIcon
                sx={{ fontSize: 40, color: "primary.main" }}
              />
            )}
          </Box>
        </Box>

        <Alert severity="info" sx={{ maxWidth: 600 }}>
          {openingGallery
            ? "You can also browse all our services using the tabs above."
            : "You can also browse all our services using the tabs above."}
        </Alert>
      </Box>
    );
  }

  const getCurrentTabName = () => {
    if (activeTab === 0) return "All Services";
    if (categories && categories[activeTab - 1]) {
      return categories[activeTab - 1].name;
    }
    return "Services";
  };

  const VideoBackground = ({ videoSrc }) => {
    const videoRef = useRef(null);

    useEffect(() => {
      const videoElement = videoRef.current;

      if (!videoElement) return;

      // Set muted for autoplay
      videoElement.muted = true;

      // Play video with promise handling
      const playPromise = videoElement.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video played successfully
          })
          .catch((error) => {
            // Ignore specific errors related to removal/interruption
            if (
              error.name !== "AbortError" &&
              !error.message.includes("removed") &&
              !error.message.includes("interrupted")
            ) {
              console.log("Video play failed:", error);
            }
          });
      }

      // Cleanup
      return () => {
        if (videoElement) {
          videoElement.pause();
          videoElement.currentTime = 0;
        }
      };
    }, []);

    return (
      <Box
        component="video"
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -2,
        }}
      >
        <source src={videoSrc} type="video/mp4" />
      </Box>
    );
  };

  return (
    <div className="services-page-container">
      {/* Hero Section */}
      <Navigation />
      <Box
        className="services-hero-section"
        sx={{
          position: "relative",
          padding: "100px 0",
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {/* Video Background */}
        <VideoBackground videoSrc={Service_decodia} />

        {/* Dark Overlay for text readability */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: -1,
          }}
        />

        <Container maxWidth="lg" className="services-hero-content">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Stack spacing={3}>
                <Typography
                  className="services-title"
                  variant="h4"
                  sx={{
                    fontSize: { xs: "1.0rem", sm: "2.5rem", md: "2.5rem" },
                    textTransform: "uppercase",
                    py: 4,
                    color: "white",
                  }}
                >
                  {hero?.title}
                </Typography>

                <Typography
                  className="services-subtitle"
                  variant="h6"
                  sx={{
                    fontSize: { xs: "1rem", sm: "1.2rem" },
                    color: "rgba(255, 255, 255, 0.9)",
                    textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)",
                  }}
                >
                  {hero?.subtitle}
                </Typography>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  alignItems={{ xs: "stretch", sm: "center" }}
                >
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => setOpenForm(true)}
                    endIcon={<ArrowForwardIcon />}
                    className="cta-button-primary"
                    sx={{
                      px: { xs: 3, sm: 4 },
                      py: { xs: 1.25, sm: 1.5 },
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                      backgroundColor: "#FF6B35",
                      "&:hover": {
                        backgroundColor: "#E55A2B",
                      },
                    }}
                  >
                    Book Free Consultation
                  </Button>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                className="services-hero-stats"
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: { xs: "center", md: "flex-start" },
                  alignItems: { xs: "center", md: "flex-start" },
                  gap: { xs: 3, md: 4 },
                  mt: { xs: 4, md: 0 },
                  width: "100%",
                }}
              >
                {/* {hero?.stats?.map((stat, index) => (
                  <Box
                    className="hero-stat-item"
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: { xs: "center", md: "flex-start" },
                      textAlign: { xs: "center", md: "left" },
                      minWidth: { xs: "100%", sm: "auto" },
                      flex: { xs: "1 0 auto", md: "0 1 auto" },
                    }}
                  >
                    {React.cloneElement(stat.icon, {
                      sx: {
                        fontSize: { xs: 24, sm: 30 },
                        color: stat.color,
                        mb: 1,
                      },
                    })}
                    <Box sx={{ textAlign: "inherit" }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontWeight: 800,
                          color: "white",
                          mb: 0.5,
                          fontSize: {
                            xs: "1.5rem",
                            sm: "2rem",
                            md: "2.5rem",
                          },
                          textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        {stat.value}
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        sx={{
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                          color: "rgba(255, 255, 255, 0.9)",
                        }}
                      >
                        {stat.label}
                      </Typography>
                    </Box>
                  </Box>
                ))} */}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Categories Tabs */}
      <Box className="categories-section">
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: { xs: 4, sm: 6 } }}>
            <Typography
              className="section-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                color: "#2b2b35ff",
                fontWeight: 500,
              }}
            >
              Our Service Categories
            </Typography>
            <Typography
              className="section-subtitle"
              variant="h6"
              color="text.secondary"
              sx={{
                maxWidth: 700,
                mx: "auto",
                fontSize: { xs: "1rem", sm: "1.25rem" },
                px: 2,
              }}
            >
              Explore our comprehensive range of interior design services
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              mb: { xs: 4, sm: 6 },
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant={isMobile ? "scrollable" : "fullWidth"}
              scrollButtons={isMobile ? "auto" : false}
              allowScrollButtonsMobile
              className="category-tabs"
              sx={{
                "& .MuiTab-root": {
                  fontWeight: 600,
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  minHeight: 64,
                },
              }}
            >
              <Tab label="All Services" />
              {categories?.map((category, index) => (
                <Tab
                  key={category.id}
                  label={category.name}
                  icon={category.icon}
                  iconPosition="start"
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor:
                        tabSelected && galleryType
                          ? "rgba(255, 107, 53, 0.1)"
                          : "rgba(25, 118, 210, 0.1)",
                      borderBottom:
                        tabSelected && galleryType
                          ? "3px solid #FF6B35"
                          : "3px solid #1976d2",
                    },
                  }}
                />
              ))}
            </Tabs>
          </Paper>

          {/* Filter Chips */}
          <Box sx={{ mb: { xs: 4, sm: 6 } }}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              <FilterListIcon /> Filter by:
            </Typography>
            <Stack
              direction="row"
              spacing={1}
              flexWrap="wrap"
              useFlexGap
              sx={{ gap: 1 }}
            >
              {["all", "popular", "budget", "luxury", "eco-friendly"].map(
                (filter) => (
                  <Chip
                    key={filter}
                    label={filter.replace("-", " ")}
                    onClick={() => handleFilterChange(filter)}
                    variant={activeFilter === filter ? "filled" : "outlined"}
                    color="primary"
                    size={isMobile ? "small" : "medium"}
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    }}
                  />
                ),
              )}
            </Stack>
          </Box>
        </Container>
      </Box>

      {/* Services Grid */}
      <Box
        className="all-services-section"
        ref={servicesContainerRef}
        sx={{
          position: "relative",
          minHeight: navigationComplete ? "auto" : "400px",
        }}
      >
        <Container maxWidth="lg">
          {getFilteredServices().length === 0 ? (
            <Box sx={{ textAlign: "center", py: 8 }}>
              <Typography variant="h6" color="text.secondary">
                No services found for the selected filters.
              </Typography>
              <Button
                variant="outlined"
                onClick={() => {
                  dispatch(setActiveServiceTab(0));
                  dispatch(setActiveServiceFilter("all"));
                }}
                sx={{ mt: 2 }}
              >
                View All Services
              </Button>
            </Box>
          ) : (
            <Grid container spacing={3}>
              {getFilteredServices()?.map((service) => (
                <Grid item xs={12} sm={6} md={4} key={service.id}>
                  <Card
                    className="service-detail-card"
                    id={`service-${service.id}`}
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: theme.shadows[8],
                      },
                    }}
                  >
                    <Box className="service-image-container">
                      <CardMedia
                        component="img"
                        height="200"
                        image={service.image}
                        alt={service.title}
                        className="service-main-image"
                        sx={{
                          objectFit: "cover",
                          width: "100%",
                        }}
                      />
                      <Box className="service-category-badge">
                        <Chip
                          label={service.category}
                          size="small"
                          sx={{
                            background: service.color,
                            color: "white",
                            fontWeight: 600,
                          }}
                        />
                      </Box>
                      {service.isPopular && (
                        <Box className="service-popular-badge">
                          <Chip
                            label="Popular"
                            size="small"
                            color="secondary"
                            icon={<EmojiEventsIcon />}
                          />
                        </Box>
                      )}
                    </Box>
                    <CardContent
                      className="service-detail-content"
                      sx={{ flexGrow: 1 }}
                    >
                      <Box className="service-header">
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          {service.icon}
                          <Typography
                            variant="h6"
                            fontWeight={700}
                            sx={{
                              fontSize: {
                                xs: "1rem",
                                sm: "1.1rem",
                                md: "1.25rem",
                              },
                            }}
                          >
                            {service.title}
                          </Typography>
                        </Box>
                        <Rating
                          value={service.rating}
                          precision={0.1}
                          readOnly
                          size={isMobile ? "small" : "medium"}
                        />
                      </Box>

                      <Typography
                        color="text.secondary"
                        paragraph
                        sx={{
                          mb: 2,
                          fontSize: { xs: "0.875rem", sm: "0.9rem" },
                          flexGrow: 1,
                        }}
                      >
                        {service.description}
                      </Typography>

                      <Stack spacing={2}>
                        {/* Features */}
                        <Box>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            gutterBottom
                            sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
                          >
                            Key Features:
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={0.5}
                            flexWrap="wrap"
                            useFlexGap
                            sx={{ gap: 0.5 }}
                          >
                            {service.features?.map((feature, idx) => (
                              <Chip
                                key={idx}
                                label={feature}
                                size="small"
                                variant="outlined"
                                sx={{
                                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                                }}
                              />
                            ))}
                          </Stack>
                        </Box>

                        {/* Pricing */}
                        {/* <Box>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            gutterBottom
                            sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
                          >
                            Starting from:
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                          >
                            {service.pricingNote}
                          </Typography>
                        </Box> */}

                        {/* Duration */}
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <ScheduleIcon
                            sx={{
                              fontSize: { xs: 16, sm: 18 },
                              color: "text.secondary",
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
                          >
                            Duration: {service.duration}
                          </Typography>
                        </Box>

                        {/* Action Buttons */}
                        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                          <Button
                            variant="contained"
                            fullWidth
                            onClick={() => handleViewServiceDetails(service)}
                            sx={{
                              fontSize: { xs: "0.875rem", sm: "0.9rem" },
                              py: { xs: 0.75, sm: 1 },
                            }}
                          >
                            View
                          </Button>
                          <Button
                            variant="outlined"
                            fullWidth
                            onClick={() => navigate("/contact")}
                            sx={{
                              fontSize: { xs: "0.875rem", sm: "0.9rem" },
                              py: { xs: 0.75, sm: 1 },
                            }}
                          >
                            Quick Inquiry
                          </Button>
                        </Box>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Container>
      </Box>

      {/* Galleries Section - CENTERED VERSION */}
      <Box
        ref={galleriesRef}
        className="galleries-section"
        sx={{
          backgroundColor: "#b77446",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {/* COMMERCIAL GALLERY */}
        {renderGallery(
          "commercial",
          "Commercial Projects Gallery",
          "Explore our stunning commercial interior design projects",
          "#f7f4f0ff",
          commercialImages,
          <BusinessIcon sx={{ fontSize: 16, color: "#f7f4f0ff", mr: 1 }} />,
        )}

        {/* RENOVATION GALLERY */}
        {renderGallery(
          "renovation",
          "Renovation Projects Gallery",
          "Browse through our renovation and remodeling transformations",
          "#e6efe7ff",
          renovationImages,
          <HomeIcon sx={{ fontSize: 16, color: "#f7f4f0ff", mr: 1 }} />,
        )}

        {/* RESIDENTIAL GALLERY */}
        {renderGallery(
          "residential",
          "Residential Projects Gallery",
          "Discover beautiful residential interior design projects",
          "#f1eff2ff",
          residentialImages,
          <HomeIcon sx={{ fontSize: 16, color: "#f7f4f0ff", mr: 1 }} />,
        )}

        {/* NEW PROJECT GALLERY */}
        {renderGallery(
          "newProject",
          "New Projects Gallery",
          "View our new construction and project development work",
          "#f7f4f0ff",
          newProjectImages,
          <DesignServicesIcon
            sx={{ fontSize: 16, color: "#f7f4f0ff", mr: 1 }}
          />,
        )}
      </Box>

      {/* Popular Services Section */}
      <Box className="popular-services-section">
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: { xs: 4, sm: 6 } }}>
            <Typography
              className="section-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
              }}
            >
              Most Popular Services
            </Typography>
            <Typography
              className="section-subtitle"
              variant="h6"
              color="text.secondary"
              sx={{
                maxWidth: 700,
                mx: "auto",
                fontSize: { xs: "1rem", sm: "1.25rem" },
                px: 2,
              }}
            >
              Services our clients love the most
            </Typography>
          </Box>

          <Grid container spacing={3} justifyContent="center">
            {popularServices?.map((service) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={service.id}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Card
                  className="popular-service-card"
                  sx={{ maxWidth: "350px", width: "100%" }}
                >
                  <Box className="popular-service-header">
                    {service.icon}
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      sx={{
                        fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                      }}
                    >
                      {service.title}
                    </Typography>
                  </Box>
                  <CardContent>
                    <Typography
                      color="text.secondary"
                      paragraph
                      sx={{
                        mb: 2,
                        fontSize: { xs: "0.875rem", sm: "0.9rem" },
                      }}
                    >
                      {service.description}
                    </Typography>
                    <Box className="popular-service-stats">
                      <Box className="stat-item">
                        <Typography
                          variant="h4"
                          fontWeight={800}
                          color="primary"
                          sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
                        >
                          {service.projectsCompleted}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          Expertise
                        </Typography>
                      </Box>
                      <Divider orientation="vertical" flexItem />
                      <Box className="stat-item">
                        <Typography
                          variant="h4"
                          fontWeight={800}
                          color="primary"
                          sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
                        >
                          {service.satisfactionRate}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                          Creative Work
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box className="service-process-section">
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: { xs: 4, sm: 6 } }}>
            <Typography
              className="section-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
              }}
            >
              How Our Services Work
            </Typography>
            <Typography
              className="section-subtitle"
              variant="h6"
              color="text.secondary"
              sx={{
                maxWidth: 700,
                mx: "auto",
                fontSize: { xs: "1rem", sm: "1.25rem" },
                px: 2,
              }}
            >
              A seamless process from consultation to completion
            </Typography>
          </Box>

          <Grid container spacing={3} justifyContent="center">
            {serviceProcess?.map((step, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                key={step.id}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Box
                  className="service-process-step"
                  sx={{
                    maxWidth: "280px",
                    width: "100%",
                    textAlign: "center",
                    border: "1px solid #37170bff",
                  }}
                >
                  <Box className="step-number">{step.number}</Box>
                  <Box className="step-icon">{step.icon}</Box>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    gutterBottom
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: { xs: "0.875rem", sm: "0.9rem" },
                    }}
                  >
                    {step.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box
        className="benefits-section"
        sx={{
          position: "relative",
          py: { xs: 8, md: 12 },
          overflow: "hidden",
          background: `
  linear-gradient(rgba(43, 43, 53, 0.42), rgba(43, 43, 53, 0.5)),
  url("https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3870&q=80")
`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          minHeight: "600px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            position: "relative",
            zIndex: 2,
          }}
        >
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  p: { xs: 3, md: 4 },
                  borderRadius: 2,
                  backgroundColor: "transparent",
                }}
              >
                <Typography
                  className="section-title"
                  variant="h2"
                  sx={{
                    mb: 3,
                    fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                    color: "#f7f7f8ff",
                    fontWeight: 800,
                  }}
                >
                  Why Choose Our Services?
                </Typography>
                <Typography
                  variant="h6"
                  color="text.secondary"
                  sx={{
                    mb: 4,
                    fontSize: { xs: "1rem", sm: "1.25rem" },
                    fontWeight: 800,
                    color: "#f7f7f8ff",
                  }}
                >
                  {serviceBenefits?.description ||
                    "Experience excellence in interior design with our dedicated services"}
                </Typography>
                <Stack spacing={3}>
                  {serviceBenefits?.points?.map((point, index) => (
                    <Box
                      key={index}
                      className="benefit-point"
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        p: 2,
                        borderRadius: 2,
                        fontWeight: 500,
                        backgroundColor:
                          index % 2 === 0 ? "transparent" : "transparent",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          backgroundColor: "rgba(255, 107, 53, 0.1)",
                          transform: "translateX(4px)",
                        },
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: "#FF6B35",
                          fontSize: { xs: 24, sm: 28 },
                          flexShrink: 0,
                        }}
                      />
                      <Box>
                        <Typography
                          variant="subtitle1"
                          fontWeight={700}
                          sx={{
                            fontSize: { xs: "1rem", sm: "1.1rem" },
                            color: "#f7f7f7ff",
                            mb: 0.5,
                          }}
                        >
                          {point?.title || `Benefit ${index + 1}`}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="#f7f7f7ff"
                          sx={{
                            fontSize: { xs: "0.875rem", sm: "0.95rem" },
                            lineHeight: 1.6,
                          }}
                        >
                          {point?.description ||
                            "Professional service with attention to detail and quality craftsmanship."}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Stack>
                {/* 
                <Box sx={{ mt: 4, textAlign: { xs: "center", md: "left" } }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate("/free-consultation")}
                    endIcon={<ArrowForwardIcon />}
                    sx={{
                      px: 4,
                      py: 1.5,
                      fontSize: "1rem",
                      fontWeight: 600,
                      background:
                        "linear-gradient(135deg, #FF6B35 0%, #e55a2b 100%)",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #e55a2b 0%, #cc4a22 100%)",
                      },
                    }}
                  >
                    Get Started Today
                  </Button>
                </Box> */}
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  p: { xs: 2, sm: 3, md: 4 },
                  borderRadius: 2,
                  background: `
        linear-gradient(
          rgba(255,255,255,0.9),
          rgba(255,255,255,0.95)
        ),
        url("https://images.unsplash.com/photo-1521737604893-d14cc237f11d")
      `,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
                  backdropFilter: "blur(6px)",
                  textAlign: "center",
                }}
              >
                {/* Culture & Strengths Section */}
                <Box sx={{ mb: { xs: 3, md: 4 } }}>
                  <Typography
                    variant="h4"
                    sx={{
                      mb: 3,
                      fontSize: { xs: "1.3rem", sm: "1.6rem", md: "2rem" },
                      color: "#2b2b35",
                      fontWeight: 700,
                    }}
                  >
                    Our Strengths
                  </Typography>

                  <Grid container spacing={{ xs: 2, sm: 3 }}>
                    {/* Card 1 */}
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                        <Typography
                          sx={{
                            color: "#FF6B35",
                            fontWeight: 800,
                            fontSize: {
                              xs: "1.2rem",
                              sm: "1.5rem",
                              md: "1.9rem",
                            },
                            mb: 0.5,
                          }}
                        >
                          Creative Excellence
                        </Typography>
                        <Typography
                          sx={{
                            color: "#2b2b35",
                            fontWeight: 600,
                            fontSize: { xs: "0.8rem", sm: "0.95rem" },
                          }}
                        >
                          Thoughtful Design Delivery
                        </Typography>
                      </Box>
                    </Grid>

                    {/* Card 2 */}
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                        <Typography
                          sx={{
                            color: "#FF6B35",
                            fontWeight: 800,
                            fontSize: {
                              xs: "1.2rem",
                              sm: "1.5rem",
                              md: "1.9rem",
                            },
                            mb: 0.5,
                          }}
                        >
                          Positive Culture
                        </Typography>
                        <Typography
                          sx={{
                            color: "#2b2b35",
                            fontWeight: 600,
                            fontSize: { xs: "0.8rem", sm: "0.95rem" },
                          }}
                        >
                          People-First Environment
                        </Typography>
                      </Box>
                    </Grid>

                    {/* Card 3 */}
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                        <Typography
                          sx={{
                            color: "#FF6B35",
                            fontWeight: 800,
                            fontSize: {
                              xs: "1.2rem",
                              sm: "1.5rem",
                              md: "1.9rem",
                            },
                            mb: 0.5,
                          }}
                        >
                          Strong Foundations
                        </Typography>
                        <Typography
                          sx={{
                            color: "#2b2b35",
                            fontWeight: 600,
                            fontSize: { xs: "0.8rem", sm: "0.95rem" },
                          }}
                        >
                          Experience That Guides Growth
                        </Typography>
                      </Box>
                    </Grid>

                    {/* Card 4 */}
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                        <Typography
                          sx={{
                            color: "#FF6B35",
                            fontWeight: 800,
                            fontSize: {
                              xs: "1.2rem",
                              sm: "1.5rem",
                              md: "1.9rem",
                            },
                            mb: 0.5,
                          }}
                        >
                          Trusted Quality
                        </Typography>
                        <Typography
                          sx={{
                            color: "#2b2b35",
                            fontWeight: 600,
                            fontSize: { xs: "0.8rem", sm: "0.95rem" },
                          }}
                        >
                          Consistent Design Standards
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                {/* Employee Testimonial */}
                <Box
                  sx={{
                    p: { xs: 2, sm: 3 },
                    mt: 3,
                    borderRadius: 2,
                    backgroundColor: "rgba(43, 43, 53, 0.08)",
                    borderLeft: "4px solid #FF6B35",
                  }}
                >
                  <Typography
                    sx={{
                      fontStyle: "italic",
                      mb: 2,
                      color: "#2b2b35",
                      fontSize: { xs: "0.8rem", sm: "0.95rem" },
                    }}
                  >
                    "A workplace that values creativity, collaboration, and
                    continuous learning. Every idea is respected and every
                    contribution matters."
                  </Typography>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        backgroundColor: "#FF6B35",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                      }}
                    >
                      TM
                    </Box>
                    <Box textAlign="left">
                      <Typography sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
                        Team Member
                      </Typography>
                      <Typography
                        sx={{ fontSize: "0.75rem", color: "text.secondary" }}
                      >
                        Design & Consulting Team
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* Related Projects */}
      <Box className="related-projects-section">
        <Container maxWidth="lg">
          <Box className="section-header" sx={{ textAlign: "center", mb: 4 }}>
            <Box>
              <Typography
                className="section-title"
                variant="h2"
                sx={{
                  mb: 1,
                  fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                }}
              >
                Recent Projects
              </Typography>
              <Typography
                className="section-subtitle"
                variant="h6"
                color="text.secondary"
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                See how we've implemented our services
              </Typography>
            </Box>
            {/* <Button
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate("/portfolio")}
              sx={{
                width: { xs: "100%", sm: "auto" },
                mt: { xs: 2, sm: 0 },
              }}
            >
              View All Projects
            </Button> */}
          </Box>

          <Grid container spacing={3} justifyContent="center">
            {serviceProjects?.map((project) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={project.id}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Card
                  className="related-project-card"
                  sx={{
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    maxWidth: "350px",
                    width: "100%",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: theme.shadows[8],
                    },
                  }}
                >
                  <Box className="project-image-container">
                    <CardMedia
                      component="img"
                      height="200"
                      image={project.image}
                      alt={project.title}
                      sx={{
                        objectFit: "cover",
                        width: "100%",
                      }}
                    />
                    <Box className="project-category">
                      <Chip
                        label={project.category}
                        size="small"
                        sx={{
                          background: "rgba(255, 255, 255, 0.9)",
                          fontWeight: 600,
                        }}
                      />
                    </Box>
                  </Box>
                  <CardContent>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      gutterBottom
                      sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}
                    >
                      {project.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      paragraph
                      sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
                    >
                      {project.description}
                    </Typography>
                    <Box className="project-meta">
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <LocationOnIcon
                          sx={{
                            fontSize: { xs: 14, sm: 16 },
                            color: "text.secondary",
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
                        >
                          {project.location}
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <ScheduleIcon
                          sx={{
                            fontSize: { xs: 14, sm: 16 },
                            color: "text.secondary",
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
                        >
                          {project.duration}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box className="service-cta-section">
        <Container maxWidth="lg">
          <Box className="cta-content" sx={{ textAlign: "center" }}>
            <Box
              className="cta-icon"
              sx={{ display: "flex", justifyContent: "center", mb: 3 }}
            >
              <ChatBubbleIcon
                sx={{
                  fontSize: { xs: 40, sm: 50, md: 60 },
                  color: "#FF6B35",
                }}
              />
            </Box>
            <Typography
              variant="h2"
              sx={{
                textAlign: "center",
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                px: 2,
              }}
            >
              {cta?.title}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                opacity: 0.9,
                mb: { xs: 3, sm: 4 },
                fontSize: { xs: "1rem", sm: "1.25rem" },
                px: 2,
              }}
            >
              {cta?.subtitle}
            </Typography>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
              <Button
                variant="contained"
                size="large"
                onClick={() => setOpenForm(true)}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  px: { xs: 3, sm: 4, md: 5 },
                  py: { xs: 1.25, sm: 1.5 },
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  background:
                    "linear-gradient(135deg, #1976d2 0%, #FF6B35 100%)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #1565c0 0%, #e55a2b 100%)",
                  },
                }}
              >
                Book Free Consultation
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={() => (window.location.href = `tel:${cta?.phone}`)}
                sx={{
                  px: { xs: 3, sm: 4, md: 5 },
                  py: { xs: 1.25, sm: 1.5 },
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  borderColor: "#FF6B35",
                  color: "#FF6B35",
                  "&:hover": {
                    borderColor: "#e55a2b",
                    backgroundColor: "rgba(255, 107, 53, 0.04)",
                  },
                }}
              >
                Call Now: {cta?.phone}
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>

      {/* Gallery Modal */}
      <Modal
        open={galleryOpen}
        onClose={closeGallery}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.95)",
            zIndex: 9999,
          }}
        >
          <IconButton
            onClick={closeGallery}
            sx={{
              position: "absolute",
              top: { xs: 10, sm: 20 },
              right: { xs: 10, sm: 20 },
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              color: "white",
              zIndex: 10001,
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.4)",
              },
              width: { xs: 40, sm: 48 },
              height: { xs: 40, sm: 48 },
            }}
          >
            <CloseIcon fontSize={isMobile ? "medium" : "large"} />
          </IconButton>

          <IconButton
            onClick={prevImage}
            sx={{
              position: "absolute",
              left: { xs: 5, sm: 20 },
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              color: "white",
              zIndex: 10001,
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.4)",
              },
              width: { xs: 48, sm: 56 },
              height: { xs: 48, sm: 56 },
            }}
          >
            <ArrowBackIosNewIcon fontSize={isMobile ? "medium" : "large"} />
          </IconButton>

          <IconButton
            onClick={nextImage}
            sx={{
              position: "absolute",
              right: { xs: 5, sm: 20 },
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              color: "white",
              zIndex: 10001,
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.4)",
              },
              width: { xs: 48, sm: 56 },
              height: { xs: 48, sm: 56 },
            }}
          >
            <ArrowForwardIosIcon fontSize={isMobile ? "medium" : "large"} />
          </IconButton>

          {/* Image Container */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              padding: { xs: 1, sm: 2, md: 4 },
            }}
          >
            <img
              src={getCurrentImages()[currentImageIndex]?.src}
              alt={getCurrentImages()[currentImageIndex]?.title}
              style={{
                maxWidth: "100%",
                maxHeight: "90vh",
                width: "auto",
                height: "auto",
                objectFit: "contain",
                borderRadius: "8px",
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.5)",
              }}
            />
          </Box>

          {/* Image Info */}
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 100%)",
              padding: { xs: 2, sm: 3, md: 4 },
              color: "white",
              textAlign: "center",
              zIndex: 10000,
            }}
          >
            <Typography variant="h5" fontWeight={600} sx={{ mb: 1 }}>
              {getCurrentImages()[currentImageIndex]?.title}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, opacity: 0.9 }}>
              {getCurrentImages()[currentImageIndex]?.category} •{" "}
              {getGalleryTitle()}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                padding: "4px 12px",
                borderRadius: "20px",
              }}
            >
              <span>{currentImageIndex + 1}</span>
              <span>/</span>
              <span>{getCurrentImages().length}</span>
            </Typography>
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: { xs: 80, sm: 100 },
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "center",
              gap: 1,
              padding: { xs: 1, sm: 2 },
              overflowX: "auto",
              zIndex: 10000,
            }}
          >
            {getCurrentImages().map((image, index) => (
              <Box
                key={image.id}
                onClick={() => setCurrentImageIndex(index)}
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "4px",
                  overflow: "hidden",
                  cursor: "pointer",
                  border:
                    currentImageIndex === index
                      ? "3px solid #FF6B35"
                      : "3px solid transparent",
                  opacity: currentImageIndex === index ? 1 : 0.7,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    opacity: 1,
                    transform: "scale(1.05)",
                  },
                  flexShrink: 0,
                }}
              >
                <img
                  src={image.src}
                  alt={`Thumbnail ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>

      <ConsultationFormDialog
        open={openForm}
        onClose={() => setOpenForm(false)}
      />
      <ChatButton />
      {/* Service Details Popup */}
<ServiceDetailsPopup
  open={servicePopupOpen}
  onClose={handleCloseServicePopup}
  service={selectedService}
/>
    </div>
  );
};

export default Services;
